import { ReactNode } from "react";
import { Tabs } from "antd";

import localeTabsStyle from "@/shared/styles/localeTabs.module.css";

const { TabPane } = Tabs;

// Per-language content. A single locale renders just its pane; multiple locales render as a tab
// switcher with caller-supplied labels and content. forceRender mounts every pane up front so each
// locale's form fields stay registered — otherwise switching tabs would unmount inactive locales and
// drop their values and cross-locale validation state.
export default function LocaleContent({
  locales,
  renderLabel,
  renderPane,
  activeKey,
  onChange,
}: {
  locales: string[];
  renderLabel: (locale: string) => ReactNode;
  renderPane: (locale: string) => ReactNode;
  activeKey?: string;
  onChange?: (locale: string) => void;
}) {
  if (locales.length === 1) {
    return <>{renderPane(locales[0])}</>;
  }

  return (
    <Tabs className={localeTabsStyle.localeTabs} activeKey={activeKey} onChange={onChange}>
      {locales.map((locale) => (
        <TabPane tab={renderLabel(locale)} key={locale} forceRender>
          {renderPane(locale)}
        </TabPane>
      ))}
    </Tabs>
  );
}
